export const AuditInfoInactive = ({ primaryFontColor = '#ffd800' }) => {
  return (
    <svg
      id="_009-job-portal"
      data-name="009-job-portal"
      xmlns="http://www.w3.org/2000/svg"
      width="22.945"
      height="19.922"
      viewBox="0 0 22.945 19.922"
    >
      <path
        id="Path_6309"
        data-name="Path 6309"
        d="M440.8,0h3.191V3.191H440.8Z"
        transform="translate(-421.043)"
        fill={primaryFontColor}
      />
      <path
        id="Path_6311"
        data-name="Path 6311"
        d="M0,0H18.41V3.191H0Z"
        fill={primaryFontColor}
      />
      <path
        id="Path_6312"
        data-name="Path 6312"
        d="M0,101.2H22.945v1.679H0Z"
        transform="translate(0 -96.668)"
        fill={primaryFontColor}
      />
      <path
        id="Path_6313"
        data-name="Path 6313"
        d="M22.945,181.035V168.672H0v12.363H2.435v0h20.51l-7.777-10.683v3.024l7.777,5.891-2.435,1.769Z"
        transform="translate(0 -161.113)"
        fill={primaryFontColor}
      />
    </svg>
  );
};
